var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","fill":"none","stroke":"currentColor","viewBox":"0 0 12 12"}},[_c('circle',{attrs:{"cx":"6","cy":"6","r":"4.5"}}),_c('path',{attrs:{"fill":"currentColor","stroke-linejoin":"round","d":"M5.8 3.6h.4L6 6.5z"}}),_c('circle',{attrs:{"fill":"currentColor","cx":"6","cy":"8.2","r":".6","stroke":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }